/**
 * Batch 21 service-link map entries.
 *
 * Split out of contextualLinks.ts so the main file stays within the inline-edit
 * size limit. These entries are merged into SERVICE_LINK_MAP at module load.
 * See INTERNAL_LINKING_GUIDE.md for the linking rules.
 */
import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

export const BATCH21_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "hire-specialized-automation-va": {
    url: "/n8n-workflow-developer",
    anchor: /specialized automation VA/i,
    label: "hire an n8n workflow developer",
  },
  "technical-virtual-assistant-freelance": {
    url: "/n8n-workflow-developer",
    anchor: /technical virtual assistant freelance/i,
    label: "hire an n8n workflow developer",
  },
  "hire-hubspot-specialist-philippines": {
    url: "/hubspot-revops-architect",
    anchor: /HubSpot specialist in the Philippines/i,
    label: "hire a HubSpot RevOps architect",
  },
  "how-to-hire-a-remote-hubspot-certified-administrator-in-the-philippines": {
    url: "/hubspot-revops-architect",
    anchor: /remote HubSpot certified administrator in the Philippines/i,
    label: "hire a HubSpot RevOps architect",
  },
  "outsource-revenue-operations-revops-to-the-philippines": {
    url: "/gohighlevel-revops-architect",
    anchor: /revenue operations to the Philippines/i,
    label: "hire a RevOps architect",
  },
  "hire-gohighlevel-architect-philippines": {
    url: "/gohighlevel-revops-architect",
    anchor: /GoHighLevel architect in the Philippines/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "hiring-a-remote-system-architect-in-the-philippines": {
    url: "/gohighlevel-revops-architect",
    anchor: /remote system architect in the Philippines/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
